import { CorporationPositionDto } from './corporation-position.dto';
import { CorporationRoleDto } from './corporation-role.dto';

import { CorporateAdminStatus } from '../../enums';

export interface CorporateAdminDto {
  /** format: uuid */
  id: string;

  /** format: uuid */
  corporationId: string;

  /** format: uuid */
  locationId?: string;

  /** format: uuid */
  positionId?: string;

  /** format: uuid */
  roleId?: string;

  /** format: uuid */
  userId?: string;

  firstName?: string;

  lastName?: string;

  email?: string;

  contactNumber?: string;

  /** format: date */
  hireDate?: string;

  /** format: date */
  terminationDate?: string;

  terminationReason?: string;

  isRehireEligible: boolean;

  status: CorporateAdminStatus;

  isActive: boolean;

  /** format: date-time */
  createdAt: string;

  /** format: date-time */
  updatedAt?: string;

  hasFacility?: boolean;

  position?: CorporationPositionDto;

  role?: CorporationRoleDto;
}
